module.exports = __webpack_public_path__ + "img/filter.f4b422f5.svg";